export default {
  // 共通
  QUESTIONNAIRE_REQUEST_TITLE: "Survey Request",
  QUESTIONNAIRE_REQUEST_DESCRIPTION:
    "We have decided to conduct a survey to improve the quality of our services. We would appreciate your cooperation for the improvement of our future services.",
  QUESTIONNAIRE_TEXT_AREA_PLACEHOLDER: "Please fill in the details here if you have selected 'Other'.",
  SEND_QUESTIONNAIRE: "Submit the survey",
};
